/**
 * Query keys for care timeline data.
 *
 * Keep these stable and parameterized by userId and query params.
 */
export const careTimelineKeys = {
  all: ['care-timeline'] as const,
  byUser: (userId: string) => [...careTimelineKeys.all, 'user', userId] as const,
  timeline: (userId: string, params?: Record<string, unknown>) =>
    [...careTimelineKeys.byUser(userId), 'timeline', params ?? null] as const,
};
